import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyForATransformation() {
  return <section data-section-id="225415" id="ready-to-forge" className="bg-primary text-primary-foreground relative py-24 md:py-32 px-4 overflow-hidden flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1677036/img/digital_forge_circuitry_overlay.png)] bg-cover bg-center bg-fixed opacity-10 mix-blend-multiply" aria-hidden="true" />

      {}
      <div className="relative z-10 w-full max-w-4xl mx-auto bg-primary/5 backdrop-blur-sm border border-primary-foreground/10 rounded-md p-8 md:p-16 text-center shadow-xl">
        <h2 className="text-3xl md:text-5xl lg:text-7xl font-default font-bold text-primary-foreground mb-8 leading-tight tracking-tighter uppercase">
          Ready to Forge?
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 bg-foreground text-background hover:bg-foreground/90 rounded-md shadow-md">
            <Link to="/StartAProjectPage">Connect Now</Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 border-foreground/30 text-foreground hover:bg-foreground/10 hover:text-foreground dark:border-foreground/30 dark:text-foreground dark:hover:bg-foreground/10 dark:hover:text-foreground bg-transparent rounded-md">
            
          </Button>
        </div>
      </div>
    </section>;
}